import { render, staticRenderFns } from "./SkeletonAdvertisement.vue?vue&type=template&id=f44d51b8&scoped=true"
import script from "./SkeletonAdvertisement.vue?vue&type=script&lang=js"
export * from "./SkeletonAdvertisement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d51b8",
  null
  
)

export default component.exports